import React, { useContext } from 'react'

export const AuthContext = React.createContext({ isAuth: false })

export function useAuthContext() {
  return useContext(AuthContext)
}
